module.exports = __webpack_public_path__ + "assets/img/fuzhang_cover.94400fe6.png";